import React from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table";

const EventsLogTableComponent = ({ events, columns }) => {
  return (
    <div className="overflow-auto">
      <Table>
        <TableHeader>
          <TableRow>
            {columns.map((col, index) => (
              <TableHead 
                key={index} 
                className="sticky top-0 bg-gray-100 p-5 font-bold text-gray-600 text-sm"
              >
                {col.header}
              </TableHead>
            ))}
          </TableRow>
        </TableHeader>
        <TableBody>
          {events.length !== 0 ? (
            events.map((row, rowIndex) => (
              <TableRow key={rowIndex}>
                {columns.map((col, colIndex) => (
                  <TableCell key={colIndex} className="p-5 border-b-0">
                    {col.field === "createdAt" && col.header === "DATE"
                      ? new Date(row.createdAt).toISOString().split("T")[0]
                      : col.field === "createdAt" && col.header === "HOUR"
                      ? new Date(row.createdAt)
                          .toISOString()
                          .split("T")[1]
                          .slice(0, 5)
                      : row[col.field]}
                  </TableCell>
                ))}
              </TableRow>
            ))
          ) : (
            <TableRow>
              <TableCell colSpan={columns.length} className="text-center">
                <div className="font-bold text-gray-600 text-lg">
                  There is no events
                </div>
              </TableCell>
            </TableRow>
          )}
        </TableBody>
      </Table>
    </div>
  );
};

export default EventsLogTableComponent; 